module.exports = _.first;